export default "<iframe id=\"frame\" src=\"./mapas/#\" width=\"100%\" height=\"800\" frameBorder=\"0\">\r\n  No Compatible con Frames\r\n</iframe>"